import { Link } from "react-router-dom";
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import Icon from "../Icon";
import { SidebarGlobal } from "../_Sidebar";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { Pop } from "../PopModal";
import { qreq } from "../../shared/qrequest";

class RoleList extends BaseCom {

    async componentDidMount() {
        await this.load();
        SidebarGlobal.setSubNav(<>
            <button type="button" className="btn btn-primary" onClick={() => this.props.navigate('/role/new')}>
                <Icon icon="faPlus" /> New Role
            </button>
        </>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {
        await this.fillListAsync('/api/role/list', 'list');
    }

    delete = (item) => {
        Pop.showConfirm(<>Are you sure you want to delete this role?</>, 'Delete Role', async () => {
            try {
                let j = await qreq.postAsync('/api/role/delete', { id: item.id });
                if (j.errorCode !== 0)
                    this.alert(j.errorMessage);
                else {
                    this.success('Role Deleted!');
                    await this.load();
                }
            }
            catch (e) {
                console.error(e);
                this.unkownErrorCallback();
            }
        });
    }

    render() {
        return (
            <div className="container-fluid">
                <h1>Roles</h1>
                <DataTable
                    data={this.state.list || []}
                    columns={[
                        {
                            name: 'edit', title: '',
                            valueFunc: (row) => (
                                <Link to={'/role/edit/' + row.id}>
                                    <Icon icon="faPencil" />
                                </Link>
                            ), style: { width: '50px' }
                        },
                        {
                            name: 'delete', title: '',
                            valueFunc: (row) => (
                                <span role="button" className="text-danger" onClick={() => this.delete(row)}>
                                    <Icon icon="faTrash" />
                                </span>
                            ), style: { width: '50px' }
                        },
                        {
                            name: 'name', title: 'Role',
                            valueFunc: (row) => <Link to={'/role/edit/' + row.id}>{row.name}</Link>
                        },
                    ]}
                />
            </div>
        );
    }
}

export default withParamsAndNavigate(RoleList);